/** @format */

import { Accordion, Carousel } from "react-bootstrap";

import React from "react";

const ExampleCarouselImage: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div>
      <img className="w-100" src="https://placehold.it/800x600" alt={text} />
    </div>
  );
};

export const ThemeComponents = () => (
  <section id="components">
    <h2 className="sticky-xl-top fw-bold pt-3 pt-xl-5 pb-2 pb-xl-3">
      Components
    </h2>

    <article className="my-3" id="accordion">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Accordion</h3>
        <a
          className="d-flex align-items-center"
          href="../components/accordion/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Accordion Item #1</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Accordion Item #2</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="alerts">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Alerts</h3>
        <a className="d-flex align-items-center" href="../components/alerts/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div
              className="alert alert-primary alert-dismissible fade show"
              role="alert"
            >
              A simple primary alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="alert alert-secondary alert-dismissible fade show"
              role="alert"
            >
              A simple secondary alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="alert alert-success alert-dismissible fade show"
              role="alert"
            >
              A simple success alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              A simple danger alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="alert alert-warning alert-dismissible fade show"
              role="alert"
            >
              A simple warning alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="alert alert-info alert-dismissible fade show"
              role="alert"
            >
              A simple info alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="alert alert-light alert-dismissible fade show"
              role="alert"
            >
              A simple light alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="alert alert-dark alert-dismissible fade show"
              role="alert"
            >
              A simple dark alert with{" "}
              <a href="https://wjec.co.uk" className="alert-link">
                an example link
              </a>
              . Give it a click if you like.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="alert alert-success" role="alert">
              <h4 className="alert-heading">Well done!</h4>
              <p>
                Aww yeah, you successfully read this important alert message.
                This example text is going to run a bit longer so that you can
                see how spacing within an alert works with this kind of content.
              </p>
              <hr />
              <p className="mb-0">
                Whenever you need to, be sure to use margin utilities to keep
                things nice and tidy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="badge">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Badge</h3>
        <a className="d-flex align-items-center" href="../components/badge/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <p className="h1">
              Example heading <span className="badge bg-primary">New</span>
            </p>
            <p className="h2">
              Example heading <span className="badge bg-secondary">New</span>
            </p>
            <p className="h3">
              Example heading <span className="badge bg-success">New</span>
            </p>
            <p className="h4">
              Example heading <span className="badge bg-danger">New</span>
            </p>
            <p className="h5">
              Example heading <span className="badge text-bg-warning">New</span>
            </p>
            <p className="h6">
              Example heading <span className="badge text-bg-info">New</span>
            </p>
            <p className="h6">
              Example heading <span className="badge text-bg-light">New</span>
            </p>
            <p className="h6">
              Example heading <span className="badge bg-dark">New</span>
            </p>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <span className="badge rounded-pill bg-primary">Primary</span>
            <span className="badge rounded-pill bg-secondary">Secondary</span>
            <span className="badge rounded-pill bg-success">Success</span>
            <span className="badge rounded-pill bg-danger">Danger</span>
            <span className="badge rounded-pill text-bg-warning">Warning</span>
            <span className="badge rounded-pill text-bg-info">Info</span>
            <span className="badge rounded-pill text-bg-light">Light</span>
            <span className="badge rounded-pill bg-dark">Dark</span>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="breadcrumb">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Breadcrumb</h3>
        <a
          className="d-flex align-items-center"
          href="../components/breadcrumb/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="https://wjec.co.uk">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="https://wjec.co.uk">Library</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Data
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="buttons">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Buttons</h3>
        <a className="d-flex align-items-center" href="../components/buttons/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <button type="button" className="btn btn-primary">
              Primary
            </button>
            <button type="button" className="btn btn-secondary">
              Secondary
            </button>
            <button type="button" className="btn btn-success">
              Success
            </button>
            <button type="button" className="btn btn-danger">
              Danger
            </button>
            <button type="button" className="btn btn-warning">
              Warning
            </button>
            <button type="button" className="btn btn-info">
              Info
            </button>
            <button type="button" className="btn btn-light">
              Light
            </button>
            <button type="button" className="btn btn-dark">
              Dark
            </button>

            <button type="button" className="btn btn-link">
              Link
            </button>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <button type="button" className="btn btn-outline-primary">
              Primary
            </button>
            <button type="button" className="btn btn-outline-secondary">
              Secondary
            </button>
            <button type="button" className="btn btn-outline-success">
              Success
            </button>
            <button type="button" className="btn btn-outline-danger">
              Danger
            </button>
            <button type="button" className="btn btn-outline-warning">
              Warning
            </button>
            <button type="button" className="btn btn-outline-info">
              Info
            </button>
            <button type="button" className="btn btn-outline-light">
              Light
            </button>
            <button type="button" className="btn btn-outline-dark">
              Dark
            </button>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <button type="button" className="btn btn-primary btn-sm">
              Small button
            </button>
            <button type="button" className="btn btn-primary">
              Standard button
            </button>
            <button type="button" className="btn btn-primary btn-lg">
              Large button
            </button>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="button-group">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Button group</h3>
        <a
          className="d-flex align-items-center"
          href="../components/button-group/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div
              className="btn-toolbar"
              role="toolbar"
              aria-label="Toolbar with button groups"
            >
              <div
                className="btn-group me-2"
                role="group"
                aria-label="First group"
              >
                <button type="button" className="btn btn-secondary">
                  1
                </button>
                <button type="button" className="btn btn-secondary">
                  2
                </button>
                <button type="button" className="btn btn-secondary">
                  3
                </button>
                <button type="button" className="btn btn-secondary">
                  4
                </button>
              </div>
              <div
                className="btn-group me-2"
                role="group"
                aria-label="Second group"
              >
                <button type="button" className="btn btn-secondary">
                  5
                </button>
                <button type="button" className="btn btn-secondary">
                  6
                </button>
                <button type="button" className="btn btn-secondary">
                  7
                </button>
              </div>
              <div className="btn-group" role="group" aria-label="Third group">
                <button type="button" className="btn btn-secondary">
                  8
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="card">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Card</h3>
        <a className="d-flex align-items-center" href="../components/card/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="row  row-cols-1 row-cols-md-2 g-4">
              <div className="col">
                <div className="card">
                  <svg
                    className="bd-placeholder-img card-img-top"
                    width="100%"
                    height="180"
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-label="Placeholder: Image cap"
                    preserveAspectRatio="xMidYMid slice"
                    focusable="false"
                  >
                    <title>Placeholder</title>
                    <rect width="100%" height="100%" fill="#868e96" />
                    <text x="50%" y="50%" fill="#dee2e6" dy=".3em">
                      Image cap
                    </text>
                  </svg>

                  <div className="card-body">
                    <h5 className="card-title">Card title</h5>
                    <p className="card-text">
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </p>
                    <a href="https://wjec.co.uk" className="btn btn-primary">
                      Go somewhere
                    </a>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card">
                  <div className="card-header">Featured</div>
                  <div className="card-body">
                    <h5 className="card-title">Card title</h5>
                    <p className="card-text">
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </p>
                    <a href="https://wjec.co.uk" className="btn btn-primary">
                      Go somewhere
                    </a>
                  </div>
                  <div className="card-footer text-muted">2 days ago</div>
                </div>
              </div>
              <div className="col">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Card title</h5>
                    <p className="card-text">
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </p>
                  </div>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">An item</li>
                    <li className="list-group-item">A second item</li>
                    <li className="list-group-item">A third item</li>
                  </ul>
                  <div className="card-body">
                    <a href="https://wjec.co.uk" className="card-link">
                      Card link
                    </a>
                    <a href="https://wjec.co.uk" className="card-link">
                      Another link
                    </a>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card">
                  <div className="row g-0">
                    <div className="col-md-4">
                      <svg
                        className="bd-placeholder-img"
                        width="100%"
                        height="250"
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        aria-label="Placeholder: Image"
                        preserveAspectRatio="xMidYMid slice"
                        focusable="false"
                      >
                        <title>Placeholder</title>
                        <rect width="100%" height="100%" fill="#868e96" />
                        <text x="50%" y="50%" fill="#dee2e6" dy=".3em">
                          Image
                        </text>
                      </svg>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">Card title</h5>
                        <p className="card-text">
                          This is a wider card with supporting text below as a
                          natural lead-in to additional content. This content is
                          a little bit longer.
                        </p>
                        <p className="card-text">
                          <small className="text-muted">
                            Last updated 3 mins ago
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="carousel">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Carousel</h3>
        <a className="d-flex align-items-center" href="../components/carousel/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <Carousel>
              <Carousel.Item>
                <ExampleCarouselImage text="First slide" />
                <Carousel.Caption>
                  <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <ExampleCarouselImage text="Second slide" />
                <Carousel.Caption>
                  <h3>Second slide label</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <ExampleCarouselImage text="Third slide" />
                <Carousel.Caption>
                  <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="dropdowns">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Dropdowns</h3>
        <a
          className="d-flex align-items-center"
          href="../components/dropdowns/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="btn-group w-100 align-items-center justify-content-between flex-wrap">
              <div className="dropdown">
                <button
                  className="btn btn-secondary btn-sm dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropdown button
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <h6 className="dropdown-header">Dropdown header</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Something else here
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Separated link
                    </a>
                  </li>
                </ul>
              </div>
              <div className="dropdown">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropdown button
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <h6 className="dropdown-header">Dropdown header</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Something else here
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Separated link
                    </a>
                  </li>
                </ul>
              </div>
              <div className="dropdown">
                <button
                  className="btn btn-secondary btn-lg dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropdown button
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <h6 className="dropdown-header">Dropdown header</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Something else here
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Separated link
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="btn-group">
              <button type="button" className="btn btn-primary">
                Primary
              </button>
              <button
                type="button"
                className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="visually-hidden">Toggle Dropdown</span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Another action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            {/* btn-group */}
            <div className="btn-group">
              <button type="button" className="btn btn-secondary">
                Secondary
              </button>
              <button
                type="button"
                className="btn btn-secondary dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="visually-hidden">Toggle Dropdown</span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Another action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            {/* /btn-group */}
            <div className="btn-group">
              <button type="button" className="btn btn-success">
                Success
              </button>
              <button
                type="button"
                className="btn btn-success dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="visually-hidden">Toggle Dropdown</span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Another action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            {/* /btn-group */}
            <div className="btn-group">
              <button type="button" className="btn btn-info">
                Info
              </button>
              <button
                type="button"
                className="btn btn-info dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="visually-hidden">Toggle Dropdown</span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Another action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            {/* /btn-group */}
            <div className="btn-group">
              <button type="button" className="btn btn-warning">
                Warning
              </button>
              <button
                type="button"
                className="btn btn-warning dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="visually-hidden">Toggle Dropdown</span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Another action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            {/* /btn-group */}
            <div className="btn-group">
              <button type="button" className="btn btn-danger">
                Danger
              </button>
              <button
                type="button"
                className="btn btn-danger dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="visually-hidden">Toggle Dropdown</span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Another action
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://wjec.co.uk">
                    Something else here
                  </a>
                </li>
              </ul>
            </div>
            {/* /btn-group */}
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="btn-group w-100 align-items-center justify-content-between flex-wrap">
              <div className="dropend">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropend button
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <h6 className="dropdown-header">Dropdown header</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Something else here
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Separated link
                    </a>
                  </li>
                </ul>
              </div>
              <div className="dropup">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropup button
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <h6 className="dropdown-header">Dropdown header</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Something else here
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Separated link
                    </a>
                  </li>
                </ul>
              </div>
              <div className="dropstart">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropstart button
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <h6 className="dropdown-header">Dropdown header</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Something else here
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Separated link
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="btn-group">
              <div className="dropdown">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  End-aligned menu
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <h6 className="dropdown-header">Dropdown header</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Another action
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="https://wjec.co.uk">
                      Separated link
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="list-group">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>List group</h3>
        <a
          className="d-flex align-items-center"
          href="../components/list-group/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <ul className="list-group">
              <li className="list-group-item disabled">A disabled item</li>
              <li className="list-group-item">A second item</li>
              <li className="list-group-item">A third item</li>
              <li className="list-group-item">A fourth item</li>
              <li className="list-group-item">And a fifth one</li>
            </ul>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <ul className="list-group list-group-flush">
              <li className="list-group-item">An item</li>
              <li className="list-group-item">A second item</li>
              <li className="list-group-item">A third item</li>
              <li className="list-group-item">A fourth item</li>
              <li className="list-group-item">And a fifth one</li>
            </ul>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="list-group">
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action"
              >
                A simple default list group item
              </a>

              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-primary"
              >
                A simple primary list group item
              </a>
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-secondary"
              >
                A simple secondary list group item
              </a>
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-success"
              >
                A simple success list group item
              </a>
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-danger"
              >
                A simple danger list group item
              </a>
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-warning"
              >
                A simple warning list group item
              </a>
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-info"
              >
                A simple info list group item
              </a>
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-light"
              >
                A simple light list group item
              </a>
              <a
                href="https://wjec.co.uk"
                className="list-group-item list-group-item-action list-group-item-dark"
              >
                A simple dark list group item
              </a>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="modal">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Modal</h3>
        <a className="d-flex align-items-center" href="../components/modal/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="d-flex justify-content-between flex-wrap">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#exampleModalDefault"
              >
                Launch demo modal
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdropLive"
              >
                Launch static backdrop modal
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#exampleModalCenteredScrollable"
              >
                Vertically centered scrollable modal
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#exampleModalFullscreen"
              >
                Full screen
              </button>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="navs">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Navs</h3>
        <a
          className="d-flex align-items-center"
          href="../components/navs-tabs/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <nav className="nav">
              <a
                className="nav-link active"
                aria-current="page"
                href="https://wjec.co.uk"
              >
                Active
              </a>
              <a className="nav-link" href="https://wjec.co.uk">
                Link
              </a>
              <a className="nav-link" href="https://wjec.co.uk">
                Link
              </a>
              <a className="nav-link disabled" href="https://wjec.co.uk">
                Disabled
              </a>
            </nav>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <nav>
              <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  Home
                </button>
                <button
                  className="nav-link"
                  id="nav-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  Profile
                </button>
                <button
                  className="nav-link"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Contact
                </button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <p>
                  This is some placeholder content the{" "}
                  <strong>Home tab's</strong> associated content. Clicking
                  another tab will toggle the visibility of this one for the
                  next. The tab JavaScript swaps classes to control the content
                  visibility and styling. You can use it with tabs, pills, and
                  any other <code>.nav</code>-powered navigation.
                </p>
              </div>
              <div
                className="tab-pane fade"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <p>
                  This is some placeholder content the{" "}
                  <strong>Profile tab's</strong> associated content. Clicking
                  another tab will toggle the visibility of this one for the
                  next. The tab JavaScript swaps classes to control the content
                  visibility and styling. You can use it with tabs, pills, and
                  any other <code>.nav</code>
                  -powered navigation.
                </p>
              </div>
              <div
                className="tab-pane fade"
                id="nav-contact"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <p>
                  This is some placeholder content the{" "}
                  <strong>Contact tab's</strong> associated content. Clicking
                  another tab will toggle the visibility of this one for the
                  next. The tab JavaScript swaps classes to control the content
                  visibility and styling. You can use it with tabs, pills, and
                  any other <code>.nav</code>
                  -powered navigation.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <ul className="nav nav-pills">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="https://wjec.co.uk"
                >
                  Active
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://wjec.co.uk">
                  Link
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://wjec.co.uk">
                  Link
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link disabled" href="httsp://wjec.co.uk">
                  Disabled
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="navbar">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Navbar</h3>
        <a className="d-flex align-items-center" href="../components/navbar/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <nav className="navbar navbar-expand-lg bg-light">
              <div className="container-fluid">
                <a className="navbar-brand" href="https://wjec.co.uk">
                  <img
                    src="../assets/brand/bootstrap-logo-white.svg"
                    width="38"
                    height="30"
                    className="d-inline-block align-top"
                    alt="Bootstrap"
                    loading="lazy"
                    style={{
                      filter: "invert(1) grayscale(100%) brightness(200%)",
                    }}
                  />
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        aria-current="page"
                        href="https://wjec.co.uk"
                      >
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="https://wjec.co.uk">
                        Link
                      </a>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="https://wjec.co.uk"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Dropdown
                      </a>
                      <ul className="dropdown-menu">
                        <li>
                          <a
                            className="dropdown-item"
                            href="https://wjec.co.uk"
                          >
                            Action
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="https://wjec.co.uk"
                          >
                            Another action
                          </a>
                        </li>
                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="https://wjec.co.uk"
                          >
                            Something else here
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link disabled"
                        href="httsp://wjec.co.uk"
                      >
                        Disabled
                      </a>
                    </li>
                  </ul>
                  <form className="d-flex" role="search">
                    <input
                      className="form-control me-2"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                    />
                    <button className="btn btn-outline-dark" type="submit">
                      Search
                    </button>
                  </form>
                </div>
              </div>
            </nav>

            <nav className="navbar navbar-expand-lg navbar-dark bg-primary mt-5">
              <div className="container-fluid">
                <a className="navbar-brand" href="https://wjec.co.uk">
                  <img
                    src="../assets/brand/bootstrap-logo-white.svg"
                    width="38"
                    height="30"
                    className="d-inline-block align-top"
                    alt="Bootstrap"
                    loading="lazy"
                  />
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent2"
                  aria-controls="navbarSupportedContent2"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent2"
                >
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        aria-current="page"
                        href="https://wjec.co.uk"
                      >
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="https://wjec.co.uk">
                        Link
                      </a>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="https://wjec.co.uk"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Dropdown
                      </a>
                      <ul className="dropdown-menu">
                        <li>
                          <a
                            className="dropdown-item"
                            href="https://wjec.co.uk"
                          >
                            Action
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="https://wjec.co.uk"
                          >
                            Another action
                          </a>
                        </li>
                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="https://wjec.co.uk"
                          >
                            Something else here
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link disabled"
                        href="httsp://wjec.co.uk"
                      >
                        Disabled
                      </a>
                    </li>
                  </ul>
                  <form className="d-flex" role="search">
                    <input
                      className="form-control me-2"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                    />
                    <button className="btn btn-outline-light" type="submit">
                      Search
                    </button>
                  </form>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="pagination">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Pagination</h3>
        <a
          className="d-flex align-items-center"
          href="../components/pagination/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <nav aria-label="Pagination example">
              <ul className="pagination pagination-sm">
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    1
                  </a>
                </li>
                <li className="page-item active" aria-current="page">
                  <a className="page-link" href="https://wjec.co.uk">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    3
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <nav aria-label="Standard pagination example">
              <ul className="pagination">
                <li className="page-item">
                  <a
                    className="page-link"
                    href="https://wjec.co.uk"
                    aria-label="Previous"
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a
                    className="page-link"
                    href="https://wjec.co.uk"
                    aria-label="Next"
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <nav aria-label="Another pagination example">
              <ul className="pagination pagination-lg flex-wrap">
                <li className="page-item disabled">
                  <a className="page-link" href="httsp://wjec.co.uk">
                    Previous
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    1
                  </a>
                </li>
                <li className="page-item active" aria-current="page">
                  <a className="page-link" href="https://wjec.co.uk">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="https://wjec.co.uk">
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="popovers">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Popovers</h3>
        <a className="d-flex align-items-center" href="../components/popovers/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <button
              type="button"
              className="btn btn-lg btn-danger"
              data-bs-toggle="popover"
              title="Popover title"
              data-bs-content="And here's some amazing content. It's very engaging. Right?"
            >
              Click to toggle popover
            </button>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-container="body"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
            >
              Popover on top
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-container="body"
              data-bs-toggle="popover"
              data-bs-placement="right"
              data-bs-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
            >
              Popover on end
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-container="body"
              data-bs-toggle="popover"
              data-bs-placement="bottom"
              data-bs-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
            >
              Popover on bottom
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-container="body"
              data-bs-toggle="popover"
              data-bs-placement="left"
              data-bs-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
            >
              Popover on start
            </button>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="progress">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Progress</h3>
        <a className="d-flex align-items-center" href="../components/progress/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="progress mb-3">
              <div
                className="progress-bar"
                role="progressbar"
                aria-label="Example with label"
                aria-valuenow={0}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                0%
              </div>
            </div>
            <div className="progress mb-3">
              <div
                className="progress-bar bg-success w-25"
                role="progressbar"
                aria-label="Success example with label"
                aria-valuenow={25}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                25%
              </div>
            </div>
            <div className="progress mb-3">
              <div
                className="progress-bar text-bg-info w-50"
                role="progressbar"
                aria-label="Info example with label"
                aria-valuenow={50}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                50%
              </div>
            </div>
            <div className="progress mb-3">
              <div
                className="progress-bar text-bg-warning w-75"
                role="progressbar"
                aria-label="Warning example with label"
                aria-valuenow={75}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                75%
              </div>
            </div>
            <div className="progress">
              <div
                className="progress-bar bg-danger w-100"
                role="progressbar"
                aria-label="Danger example with label"
                aria-valuenow={100}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                100%
              </div>
            </div>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                aria-label="Segment one - default example"
                style={{ width: "15%" }}
                aria-valuenow={15}
                aria-valuemin={0}
                aria-valuemax={100}
              ></div>
              <div
                className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                role="progressbar"
                aria-label="Segment two - animated striped success example"
                style={{ width: "40%" }}
                aria-valuenow={40}
                aria-valuemin={0}
                aria-valuemax={100}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="scrollspy">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Scrollspy</h3>
        <a
          className="d-flex align-items-center"
          href="../components/scrollspy/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example">
          <nav id="navbar-example2" className="navbar bg-light px-3">
            <a className="navbar-brand" href="https://wjec.co.uk">
              Navbar
            </a>
            <ul className="nav nav-pills">
              <li className="nav-item">
                <a className="nav-link active" href="#scrollspyHeading1">
                  First
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#scrollspyHeading2">
                  Second
                </a>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  href="https://wjec.co.uk"
                  role="button"
                  aria-expanded="false"
                >
                  Dropdown
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="#scrollspyHeading3">
                      Third
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#scrollspyHeading4">
                      Fourth
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="#scrollspyHeading5">
                      Fifth
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
          <div
            data-bs-spy="scroll"
            data-bs-target="#navbar-example2"
            data-bs-offset="0"
            className="scrollspy-example position-relative mt-2 overflow-auto"
            tabIndex={0}
          >
            <h4 id="scrollspyHeading1">First heading</h4>
            <p>
              This is some placeholder content for the scrollspy page. Note that
              as you scroll down the page, the appropriate navigation link is
              highlighted. It's repeated throughout the component example. We
              keep adding some more example copy here to emphasize the scrolling
              and highlighting.
            </p>
            <h4 id="scrollspyHeading2">Second heading</h4>
            <p>
              This is some placeholder content for the scrollspy page. Note that
              as you scroll down the page, the appropriate navigation link is
              highlighted. It's repeated throughout the component example. We
              keep adding some more example copy here to emphasize the scrolling
              and highlighting.
            </p>
            <h4 id="scrollspyHeading3">Third heading</h4>
            <p>
              This is some placeholder content for the scrollspy page. Note that
              as you scroll down the page, the appropriate navigation link is
              highlighted. It's repeated throughout the component example. We
              keep adding some more example copy here to emphasize the scrolling
              and highlighting.
            </p>
            <h4 id="scrollspyHeading4">Fourth heading</h4>
            <p>
              This is some placeholder content for the scrollspy page. Note that
              as you scroll down the page, the appropriate navigation link is
              highlighted. It's repeated throughout the component example. We
              keep adding some more example copy here to emphasize the scrolling
              and highlighting.
            </p>
            <h4 id="scrollspyHeading5">Fifth heading</h4>
            <p>
              This is some placeholder content for the scrollspy page. Note that
              as you scroll down the page, the appropriate navigation link is
              highlighted. It's repeated throughout the component example. We
              keep adding some more example copy here to emphasize the scrolling
              and highlighting.
            </p>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="spinners">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Spinners</h3>
        <a className="d-flex align-items-center" href="../components/spinners/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-border text-danger" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-border text-warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-border text-info" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-border text-dark" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="spinner-grow text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow text-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow text-danger" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow text-warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow text-info" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow text-dark" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="toasts">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Toasts</h3>
        <a className="d-flex align-items-center" href="../components/toasts/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example bg-dark p-5 align-items-center">
            <div
              className="toast"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
            >
              <div className="toast-header">
                <svg
                  className="bd-placeholder-img rounded me-2"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <rect width="100%" height="100%" fill="#007aff" />
                </svg>

                <strong className="me-auto">Bootstrap</strong>
                <small className="text-muted">11 mins ago</small>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="toast"
                  aria-label="Close"
                ></button>
              </div>
              <div className="toast-body">
                Hello, world! This is a toast message.
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="mt-3 mb-5 pb-5" id="tooltips">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Tooltips</h3>
        <a className="d-flex align-items-center" href="../components/tooltips/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example tooltip-demo">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Tooltip on top"
            >
              Tooltip on top
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Tooltip on end"
            >
              Tooltip on end
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="Tooltip on bottom"
            >
              Tooltip on bottom
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="left"
              title="Tooltip on start"
            >
              Tooltip on start
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-html="true"
              title="<em>Tooltip</em> <u>with</u> <b>HTML</b>"
            >
              Tooltip with HTML
            </button>
          </div>
        </div>
      </div>
    </article>
  </section>
);

export default ThemeComponents;
